import React, { useContext } from "react";
import { COLLEGE } from "../../../../utils";
import PsContext from "../../../../context";

const Style1 = () => {
  const context = useContext(PsContext);
  const cards = [
    {
      title: "Photograph Image",
      specs: "200 × 230 px | 50 KB to 1 MB",
      icon: "camera",
      desc: "White background, clear face, no sunglasses.",
    },
    {
      title: "Signature Image",
      specs: "140 × 60 px | 30 KB to 1 MB",
      icon: "file-signature",
      desc: "Black ink, clear scan, cropped correctly.",
    },
    {
      title: "Payment Options",
      specs: "Safe & Secure Hub",
      icon: "credit-card",
      desc: "Net banking | Credit / Debit Card | UPI | Wallet",
    },
  ];

  return (
    <div className="text-center text-md-start slide-up-animation pb-2">
      <div className="d-inline-flex align-items-center bg-white bg-opacity-10 border border-white border-opacity-25 rounded-pill px-3 py-1 mb-3 backdrop-blur shadow-sm sliding-pill">
        <span className="badge bg-warning text-dark rounded-pill me-2 only-new-sliding">
          NEW
        </span>
        <span className="text-white fs-13 fw-600 letter-spacing-1 admission-text-fixed">
          Admissions Platform
        </span>
      </div>
      <h3 className="text-white fw-900 display-4 mb-2 text-shadow-sm">
        Welcome to {COLLEGE || "Our"} Admissions
      </h3>
      <p className="text-light fs-16 fw-500 opacity-75 max-w-600 mx-auto mx-md-0">
        Begin your academic journey today. Experience our seamless and fully
        digital enrollment process.
      </p>

      <div className="marquee-container mt-4 slide-up-animation-delay-1 px-0 mb-5">
        <div className="marquee-inner">
          {[...cards, ...cards, ...cards].map((item, index) => {
            const variantNumber = (index % 6) + 1;
            return (
              <div
                key={index}
                className={`marquee-card mx-3 step-variant-${variantNumber}`}
              >
                <div className="d-flex align-items-center mb-3">
                  <div
                    className="program-icon-box px-3 py-2 rounded-1 me-3"
                    style={{ width: "35px", height: "35px" }}
                  >
                    <i className={`fa fa-solid fa-${item.icon} fs-16`}></i>
                  </div>
                  <h5 className="fw-700 m-0 fs-16 text-dark text-nowrap">
                    {item.title}
                  </h5>
                </div>
                <div className="bg-light p-1 rounded mb-3">
                  <small className="text-muted text-uppercase fw-600 fs-10 letter-spacing-1 d-block mb-1">
                    Specifications
                  </small>
                  <p className="text-dark fw-700 fs-14 m-0 text-nowrap">
                    {item.specs}
                  </p>
                </div>
                <p className="text-muted fs-12 mb-0 line-clamp-2">
                  {item.desc}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default Style1;
